import { chainMetadataById } from '@funkit/chains'

import { FALLBACK_ASSET_LOGO } from '../icons/assetLogos'

// How a chain is shown, read from `@funkit/chains` — the metadata both SDKs
// already share. The fallbacks are the platform-specific half: the CDN
// placeholder and the locale string are RN's own.

/** Chain logo, or the placeholder for a chain the metadata doesn't cover. */
export function chainIconUri(chainId: number): string {
  return chainMetadataById[chainId]?.iconUrl ?? FALLBACK_ASSET_LOGO
}

/**
 * The chain's name, or `undefined` when the metadata doesn't know it — callers
 * supply their own fallback, since not all of them have a `t` to hand.
 */
export function chainName(chainId: number): string | undefined {
  return chainMetadataById[chainId]?.name
}
